const VisPageResetPassword = () => import('@/views/vis-page-reset-password');

export default [
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: VisPageResetPassword,
    props: route => ({ state: route.query.state })
  }
]
